import Styles from "./media.module.css";
import { Headline, Image, Attribute, ProHeadline } from "../../subcomponents/subcomponents";
export const Media       = ( props ) => {
    const { media = [], filter } = props;
    const { Media } = Styles;
    return (
        <main className={ Media }>
            {
                media.map(( value, key ) => {
                    const { image, imageTheme, filesNumber, size, cost, name, nameTheme, link, category } = value;
                    return filter === "All" ? 
                        <Medium 
                            image       = { image       }
                            imageTheme  = { imageTheme  }
                            filesNumber = { filesNumber }
                            size        = { size        }
                            cost        = { cost        }
                            name        = { name        }
                            nameTheme   = { nameTheme   }
                            link        = { link        }
                            key         = { key         }
                        /> : 
                        filter === category && 
                        <Medium 
                            image       = { image       }
                            imageTheme  = { imageTheme  } 
                            filesNumber = { filesNumber } 
                            size        = { size        } 
                            cost        = { cost        }
                            name        = { name        } 
                            nameTheme   = { nameTheme   } 
                            link        = { link        } 
                            key         = { key         } 
                        />;
                })
            }
        </main>
    );
};
export const MediaHeader = ( props ) => {
    const { setFilter, headlines = [] } = props;
    const { MediaHeader } = Styles;
    const Attributes = [
        { 
            icon    : <i className="bi bi-globe"></i>, 
            span    : <span></span>, 
            text    : "All", 
            onClick : (e) => setFilter("All") 
        },
        { 
            icon    : <i className="bi bi-terminal-fill" style={{ color: "#9c27b0" }}></i>, 
            span    : <span style={{ backgroundColor: "#9c27b0" }}></span>, 
            text    : "Programming", 
            color   : "#9c27b0", 
            onClick : (e) => setFilter("programming") 
        },
        { 
            icon    : <i className="bi bi-calculator-fill" style={{ color: "#3f51b5" }}></i>, 
            span    : <span style={{ backgroundColor: "#3f51b5" }}></span>, 
            text    : "Math", 
            color   : "#3f51b5", 
            onClick : (e) => setFilter("math") 
        },
        { 
            icon    : <i className="bi bi-play-circle-fill" style={{ color: "#009688" }}></i>, 
            span    : <span style={{ backgroundColor: "#009688" }}></span>, 
            text    : "Media", 
            color   : "#009688", 
            onClick : (e) => setFilter("media") 
        },
        { 
            icon    : <i className="bi bi-film" style={{ color: "#cddc39" }}></i>, 
            span    : <span style={{ backgroundColor: "#cddc39" }}></span>, 
            text    : "Films", 
            color   : "#cddc39", 
            onClick : (e) => setFilter("films") 
        },
    ];    
    return (
        <header className={ MediaHeader }>
            <Attribute   Attributes = { Attributes }/>
            <ProHeadline headlines  = { headlines  }/>
        </header>
    );
};
const Medium             = ( props ) => {
    const { image, imageTheme, filesNumber, size, cost, name, nameTheme, link } = props;
    const { Medium } = Styles;
    const Attributes = [
        { 
            icon   : <i className="bi bi-archive-fill"></i>, 
            span   : <span></span>, 
            text   : size 
        },
        { 
            icon   : <i className="bi bi-file-earmark-fill"></i>, 
            span   : <span></span>, 
            text   : filesNumber 
        },
        { 
            text   : cost, 
            fontFamily : "BRLNSDB", 
            color  : "#4caf50"
        },
        { 
            icon   : <i className="bi bi-folder-symlink-fill" style={{ color: "#cddc39" }}></i>, 
            span   : <span style={{ display: "none" }}></span>,
            link   : link,
        },
    ];    
    return (
        <div className={ Medium }>
            <Image
                src   = { image      }
                theme = { imageTheme }
                link  = { link       }
            />
            <Attribute
                Attributes = { Attributes }
                width      = { 400        }
            />
            <Headline 
                icon  = { <i className="bi bi-folder-fill"></i> } 
                text  = { name                                  }
                width = { 400                                   }
                theme = { nameTheme                             }
                link  = { link                                  }
            />
        </div>
    );
};